import React from 'react';

import { debounce } from 'underscore';

export function useDebounce<TCallback extends (...args: any[]) => any>({
  callback,
  delay,
}: {
  callback: TCallback;
  delay: number;
}) {
  const callbackRef = React.useRef<TCallback>(callback);
  React.useLayoutEffect(() => {
    callbackRef.current = callback;
  });
  return React.useMemo(
    () => debounce((...args: any[]) => callbackRef.current(...args), delay),
    [delay]
  );
}
